import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import { I18nVerificationDescLoader } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const VERIFICATION_I18N_LOADER: DiToken<I18nVerificationDescLoader> = new DiToken<I18nVerificationDescLoader>(
  'VERIFICATION_I18N_LOADER',
  {
    factory: () => () => Promise.resolve(undefined)
  }
);
